import { render, staticRenderFns } from "./DialogSimple.vue?vue&type=template&id=26e603d1&"
import script from "./DialogSimple.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogSimple.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports